import script from "./UploadTaskItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadTaskItem.vue?vue&type=script&setup=true&lang=js"

import "./UploadTaskItem.vue?vue&type=style&index=0&id=e4feea8a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4feea8a"]])

export default __exports__